import teras from '@/teras'
import aes from './aes'
import { Axios } from 'axios'

class tAxios extends Axios {
  constructor (args) {
    super({
      withCredentials:  ((process.env.NODE_ENV != 'development') ? true : false),
      validateStatus: function(status) {return status >= 200 && status < 300 && status != 210 },
      transformResponse: [(data) => {
        if (typeof data === 'string') {
          try{
            data = JSON.parse(data)
            if (typeof data.isencrypt === 'string') {
              data.data = JSON.parse(aes.decode(data.isencrypt))
            }  

          }catch(e){
            throw {message: "La risposta non è una stringa JSON valida",response:data}
          }
        }
        return data;
      }],
    })
    
    this.teras = teras
    console.log(teras)
    this.apiUrl = teras.apiUrl
    this.aes = 0 // ((process.env.NODE_ENV != 'development') ? 1 : 0)
    this.defaults.headers = {'X-Request-ID': this.teras.name,'X-aes': this.aes}
    this.rawdata = {}
    this.sessionID = ''
    this.mysql = teras.mysql
    this.sessionInterval = setInterval(() => { this.sessionGet('session_id')  }, 240000)
    
  }

  filterItems(value,items,campo){
    if(typeof items !='undefined' && items.length>0)
      for (let item of items)
      if(item.id == value) 
        return item[campo]
    return ''
  }

  sessionGet(key){
    return new Promise((resolve, reject) => {
      this.post(this.apiUrl+'vue/sessionget',{key:key}).then((response) =>  {
        resolve(response.data.data)
      })
    })
  }

  sessionSet(key,value){
    return new Promise((resolve, reject) => {
      this.post(this.apiUrl+'vue/sessionset',{key:key,value:value}).then((response) =>  {
        console.log("SETTATO SESSION KEY")
        console.log(response.data.data)
        resolve(response.data.data)
      })
    })
  }

  logout(){
    return new Promise((resolve, reject) => {this.get(this.apiUrl+'vue/logout').then((response) =>  {resolve(response)})})
  }

  page(name){
      return this.get(teras.urlsite+'/page/'+name+'.html'+'?'+new Date().getTime(),{withCredentials:false, responseType: 'document'}).then(function (response) {
         return {
            title: response.request.response.body.children.item(0).innerHTML,
            testo: response.request.response.body.children.item(1).innerHTML
         }
      })
  }

  pageSave(page,url){
    return this.post(this.apiUrl+'page/save',{page:page,url:url}).then(function (response) {return response.data.data})
  }
  saveFile(data,file,url){
    return this.post(this.apiUrl+'vue/savefile',{data:data,file:file,url:url}).then(function (response) {return response.data.data})
  }

  terasEncode(value){
    return new Promise((resolve, reject) => {
      this.post(this.apiUrl+'vue/encode',{key:value}).then(function (response) {
        resolve(response.data.data.key)
      }).catch((error) => {
        console.log("ERRORE NEL FARE ENCODE")
        console.log(error.message)
        reject(error)
      })
    })
  }

  /* INVIO EMAIL */
  email(emailData){
    return new Promise((resolve, reject) => {
      emailData = this.teras.objmerge({
        to:'mirko@terasmm.it',
        from:'info@terasmm.it',
        oggetto:'Nessun Oggetto',
        body:'Nessun testo inviato',
        css: this.teras.urlsite+'css/email.css'
      },emailData)
      this.post(this.apiUrl+'vue/email',emailData).then((response) =>  {
        console.log("EMAIL INVIATA")
        console.log(response.data)
        resolve(response.data.data)
      }).catch((error) => {
        console.log("ERRORE NELL'INVIO DELLA EMAIL")
        console.log(error.message)
        reject(error)
      })
    })
  }

  /* CREA PDF FROM XSL */
  pdf(fileXsl,filePdf,data){
    if(typeof data == 'object')
      data = convert.js2xml(data, {compact:true,ignoreComment: true, spaces: 4})
    if(typeof data == 'undefined')
      throw {message: "Bisogna passare un oggetto JS o una stringa xml",response:data}
    

    return new Promise((resolve, reject) => {
      this.post(this.apiUrl+'vue/pdf',{pdf:filePdf, xsl:fileXsl, xml:data}).then((response) =>  {
        resolve(response)
      }).catch((error) => {
        resolve(error)
      })
    })
  }

  /*CREA PNG FROM URL */
  png(pngData){
    pngData = this.teras.objmerge({
      site:'https://www.google.it',
      width: 1366,
      height: 1024,
      deviceScaleFactor: 1
    },pngData)
    console.log("CI PROVO")
    return new Promise((resolve, reject) => {
      this.post('http://contabo04.2dns.it:3001/png',pngData,{withCredentials:false, responseType: 'blob'}).then((response) =>  {
        console.log("FUNZIONA")
        resolve(window.URL.createObjectURL(new Blob([response.data])))
      }).catch((error) => {
        console.log("ERRORE")
        resolve(error)
      })
    })
  }

  /*CREA HTML FROM URL */
  html(pageData){
    pageData = this.teras.objmerge({
      site:'https://www.google.it',
      width: 1366,
      height: 1024,
      deviceScaleFactor: 1
    },pageData)
    console.log("CI PROVO")
    return new Promise((resolve, reject) => {
      this.post('http://contabo04.2dns.it:3001/html',pageData,{withCredentials:false, responseType: 'document'}).then((response) =>  {
        console.log("FUNZIONA")
        //console.log((new XMLSerializer()).serializeToString(response.request.response))
        resolve((new XMLSerializer()).serializeToString(response.request.response))
        //resolve(window.URL.createObjectURL(new Blob([response.data])))
      }).catch((error) => {
        console.log("ERRORE")
        resolve(error)
      })
    })
  }

  /* CREA PAGINA PER FACEBOOK */
  facebook(pageData){
    pageData = this.teras.objmerge({
      //url:'https://www.google.it',
      urlrefresh:'https://www.biomedia.net',
      title: 'Pagina di prova con TAG per facebook',
      description: 'descrione per og:description',
      file: 'facebook.html',
      filedir: '/tmp/'
    },pageData)


    var html = "<!DOCTYPE html>\n"
    html += "<html>\n"
    html += "<head>\n"
    html += "<meta charset=\"utf-8\">\n"
    html += "<title>"+pageData.title+"</title>\n"
    html += "<meta property=\"og:type\" content=\"article\" />\n"
    html += "<meta property=\"og:title\" content=\""+pageData.title+"\" />\n"
    html += "<meta property=\"og:description\" content=\""+pageData.description+"\" />\n"
    html += "<meta property=\"og:image\" content=\""+pageData.image+"\" />\n"
    //html += "<meta property=\"og:url\" content=\""+this.pageData.url+" />"
    html += "<meta http-equiv=\"refresh\" content=\"0;"+pageData.urlrefresh+"\" />\n"
    html += "</head>\n"
    html += "<body><h3>"+pageData.title+"</h3>"+pageData.description+"</body>\n"
    html += "</html>"
    
    
    
    
    console.log("CI PROVO")
    return new Promise((resolve, reject) => {
      this.post(this.apiUrl+'vue/savefile',{data:html,file:pageData.file,url:pageData.filedir}).then((response) =>  {
        console.log("FUNZIONA")
        resolve(response)
      }).catch((error) => {
        console.log("ERRORE")
        resolve(error)
      })
    })
  }
  



  query(fetch,query,params){
    return new Promise((resolve, reject) => {
      var mySql ={
        adapter: this.mysql.adapter,
        database: this.mysql.database,
        sqlFetch: fetch,
        sqlQuery: query,
        sqlParams: params
      }
      var argumentsLength = arguments.length;
      if(arguments.length>3)
          var param2set = arguments[3]
      if(arguments.length>4)
          var key2set = arguments[4]
      
      var storage =  (arguments.length>5) ? arguments[5] : false
      var step =  (arguments.length>6) ? arguments[6] : false

      if(storage && this.teras.exist(key2set)){
        console.log("++++++CARICO "+key2set+" DA STORAGE++++")
        param2set[key2set] = this.teras.load(key2set)
        if(step)
          this.teras.app.step++
      }else{
        console.log("++++++CARICO "+key2set+" DA QUERY++++")
        //console.log(arguments)

        this.post(this.apiUrl+this.mysql.composer+'/query',mySql).then((response) =>  {
          var api = response.data
          if(argumentsLength > 3 && typeof param2set != 'undefined'){
            if(typeof key2set != 'undefined'){
              param2set[key2set] = api.data.result
            }else{
              param2set = api.data.result
            }
          }
          if(storage)
            this.teras.save(key2set,api.data.result)
          if(step)
            this.teras.app.step++
          resolve(api.data)
        }).catch((error) => {
            console.log("ERROR at query")
            console.log(error)
            reject(error)
        })

      }
    })
  }

  saveRow(row,table){
    return new Promise((resolve, reject) => {
      var mySql ={
        adapter: this.mysql.adapter,
        database: this.mysql.database,
        table:table,
        row: row
      } 
      this.post(this.apiUrl+this.mysql.composer+'/save',mySql).then((response) => {
          console.log("FINITO SAVE ROW")
          resolve(response.data)
      }).catch((error) => {
        console.log("ERROR at insert rows")
        reject(error)
      }) 
    })
  }

  insertRows(rows,table){
    return new Promise((resolve, reject) => {
      var mySql ={
          db: this.mysql.db,
          table:table,
          rows: rows
      }
      this.post(this.apiUrl+this.mysql.composer+'/insertrows',mySql).then((response) =>  {
          resolve(response.data)
      }).catch((error) => {
          console.log("ERROR at insert rows")
          console.log(error)
          reject(error)
      })
    })
  }  

  deleteRow(value,table,campo='id'){
    return new Promise((resolve, reject) => {
      var mySql ={
          adapter: this.mysql.adapter,
          database: this.mysql.database,
          sqlFetch: 'fetchDelete',
          sqlQuery: 'DELETE FROM ←table WHERE id=→value',
          sqlParams: {table:table,campo:campo,value:value}
      }
      this.post(this.apiUrl+this.mysql.composer+'/query',mySql).then((response) =>  {
        var api = response.data
        resolve(api.data)
      }).catch((error) => {
          console.log("ERROR at delete row")
          console.log(error)
          reject(error)
      })
    })
  }

}

export default new tAxios


// WEBPACK FOOTER //
// ./src/teras/axios.js